import type { FriendsChanged } from "@mk/shared";

/** Yalnız karşı taraftan gelen ve kullanıcı eylemi gerektiren değişiklikler. */
export function isFriendNotification(change: FriendsChanged, userId: string): boolean {
  return (
    change.actorId !== userId &&
    (change.kind === "request-created" || change.kind === "request-accepted")
  );
}
